const MDSAP_GEOS = new Set(['us', 'au', 'br', 'ca', 'jp']);

type Sortable = {
  id: string;
  title: string;
  geography: string;
  institutionGeographies?: string[];
  institutionName?: string | null;
};

function getGeoTier(source: Sortable): number {
  const geo = source.geography;
  const instGeos = source.institutionGeographies ?? [];
  const allGeos = [geo, ...instGeos];
  if (allGeos.includes('us')) return 0;
  if (allGeos.includes('eu')) return 1;
  if (source.institutionName) return 2;
  if (allGeos.some(g => MDSAP_GEOS.has(g))) return 3;
  return 4;
}

/**
 * Sort sources: selected first, then by geo tier, then alphabetical.
 */
export function sortSources<T extends Sortable>(
  items: T[],
  selectedIds: Set<string>
): T[] {
  return [...items].sort((a, b) => {
    const aSel = selectedIds.has(a.id) ? 0 : 1;
    const bSel = selectedIds.has(b.id) ? 0 : 1;
    if (aSel !== bSel) return aSel - bSel;
    const tierA = getGeoTier(a);
    const tierB = getGeoTier(b);
    if (tierA !== tierB) return tierA - tierB;
    return a.title.localeCompare(b.title);
  });
}
